<template>
	<div class="wc-packages" :class="{'special': mode == 'thankyou'}">
		<BaseCmsLabel v-if="review && data?.parcels?.length" code="packages_title" tag="div" class="wc-packages-title" :class="{'special': mode == 'thankyou'}" />
		<template v-if="data?.parcels?.length">
			<div class="wc-package" v-for="parcel in data?.parcels" :key="parcel.number">
				<div class="wc-package-header">
					<div class="wc-package-title"><BaseCmsLabel code="package" /> {{ parcel.number }} od {{ data.parcels.length }}</div>
					<div class="wc-package-seller">
						<BaseCmsLabel code="seller_item_title" />
						<template v-if="parcel.parcel_name">&nbsp;{{ parcel.parcel_name }}</template>
					</div>
				</div>
				<div v-if="review && parcel.shipping?.selected" class="wc-package-shipping" :class="{'special': parcel.shipping.selected.code == 'osobno_preuzimanje'}">
					<template v-if="parcel.shipping.selected?.code == 'osobno_preuzimanje'">
						{{ parcel.shipping.selected.title }} v <strong>{{ parcel.shipping.pickup_location.selected.title }}</strong>
						<strong> predvidoma od {{ formatDate(parcel.shipping.selected.min_date) }} do {{ formatDate(parcel.shipping.selected.max_date) }}</strong>
					</template>
					<template v-else>
						{{ parcel.shipping.selected.title }}
						<strong> predvidoma od {{ formatDate(parcel.shipping.selected.min_date) }} do {{ formatDate(parcel.shipping.selected.max_date) }}</strong>
					</template>
				</div>
				<div class="wc-package-info">
					<div class="wc-package-info-row">
						<div class="wc-package-products-img">
							<WebshopShippingItemImage v-for="itemImage in parcel.items" :key="itemImage.id" :data="itemImage" />
						</div>
						<div class="wc-package-info-more" :class="{'active': parcel.products}" @click="parcel.products = !parcel.products"><BaseCmsLabel code="order_details" /></div>
					</div>
					<div class="wc-package-products" v-if="parcel.products">
						<WebshopShippingItem v-for="item in parcel.items" :key="item.id" :data="item" />
						<div v-if="review" class="wc-packages-shipping-price">
							<div class="wc-package-shipping-title"><BaseCmsLabel code="shipping" /></div>
							<div class="wc-package-shipping-price">
								<template v-if="parcel?.shipping?.selected?.shipping_price > 0">
									<template v-if="parcel?.shipping?.selected?.discount_shipping_price != null && parcel.shipping.selected.discount_shipping_price != parcel.shipping.selected.shipping_price">
										<span v-if="parcel?.shipping?.selected?.discount_shipping_price > 0" class="price"><BaseUtilsFormatCurrency :price="parcel.shipping.selected.discount_shipping_price" /></span>
										<span v-else class="green"><BaseCmsLabel code="free" /></span>
									</template>
									<template v-else>
										<span class="price"><BaseUtilsFormatCurrency :price="parcel.shipping.selected.shipping_price" /></span>
									</template>
								</template>
								<template v-else>
									<span class="green"><BaseCmsLabel code="free" /></span>
								</template>
							</div>
						</div>
					</div>
				</div>

				<div v-if="shipping && parcel.shipping" class="wc-package-items-box" :class="{'loading': checkoutLoading}">
					<div class="wc-package-items-title">
						<template v-if="parcel.shipping.selected?.disable_change_shipping"><BaseCmsLabel code="step_shipping_choose_preorder" /></template>
						<template v-else><BaseCmsLabel code="step_shipping_choose" /></template>
					</div>
					<div class="wc-package-items">
						<div v-if="checkoutLoading || creation" class="wc-package-items-loader"></div>
						<template v-if="parcel?.shipping?.available?.length">
							<WebshopShippingOption v-for="shipping in parcel.shipping.available" :key="shipping.id" :data="shipping" :parcel="parcel" />
						</template>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script setup>
	const webshop = useWebshop();
	const props = defineProps(['shipping', 'review', 'mode', 'thankyouData']);
	const { creation, checkoutLoading } = useCheckout();

	const data = computed(() => {
		if (props.mode == 'thankyou') {
			return props.thankyouData;
		} else {
			return webshop.getCartData();
		}
	});

	function formatDate(value) {
		const d = new Date(value)
		const date = (d.getDate() < 9) ? '0' + d.getDate() : d.getDate()
		const day = d.getDay()
		const dayOfWeek = ['nedelje', 'ponedeljka', 'torka', 'srede', 'četrtka', 'petka', 'sobote']
		const month = (d.getMonth() < 9) ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)

		const dTomorrow = new Date()
		const dToday = new Date()
		let cday
		const tomorrow = dTomorrow
		const today = dToday
		tomorrow.setDate(dTomorrow.getDate() + 1)
		today.setDate(dToday.getDate())
		if (tomorrow.toDateString() === d.toDateString()) {
			cday = 'jutri'
		} else if (today.toDateString() === d.toDateString()) {
			cday = 'danes'
		} else {
			cday = dayOfWeek[day]
		}

		return cday + ', ' + date + '.' + month + '.'
	}
</script>

<style lang="less" scoped>
	.wc-packages {
		flex-grow: 1;
		position: relative;
		&.special{
			margin-top: 25px; padding-top: 30px; border-top: 1px solid @borderColor;
			@media (max-width: @m){padding-top: 25px;}
		}
	}
	.wc-packages-title {
		display: block;
		margin-bottom: 15px;
		font-size: 19px;
		font-weight: 600;
		&.special{font-size: 21px;}
	}
	.wc-package {
		width: 100%;
		margin-bottom: 20px;
	}

	.wc-package-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		min-height: 50px;
		padding: 12px 30px;
		background: linear-gradient(63.43deg, #005dad 0%, #0083be 100%);
		font-size: 17px;
		font-weight: 600;
		color: @white;
		@media (max-width: @m) {
			display: block;
			padding: 12px 15px;
			font-size: 16px;
		}
	}
	.wc-package-title {
		flex-shrink: 0;
	}
	.wc-package-seller {
		flex-grow: 1;
		padding-right: 28px;
		padding-left: 30px;
		font-size: 15px;
		text-align: right;
		position: relative;
		@media (max-width: @m) {
			margin-top: 5px;
			padding: 0;
			font-size: 14px;
			line-height: 1.3;
			text-align: left;
		}
		&:before {
			.icon-shopping-bag();
			font: 21px/21px @fonti;
			font-weight: normal;
			color: @white;
			position: absolute;
			right: 0;
			@media (max-width: @m) {
				content: none;
			}
		}
	}

	.wc-package-shipping {
		display: block;
		width: 100%;
		padding: 14px 30px 14px 67px;
		background: #f3f6fa;
		border: 1px solid @borderColor;
		border-top: none;
		font-size: 15px;
		position: relative;
		@media (max-width: @m) {
			font-size: 14px;
			line-height: 1.3;
			padding-left: 55px;
			padding-right: 15px;
			strong {
				display: block;
			}
		}
		&:before {
			.icon-delivery();
			font: 18px/1 @fonti;
			color: @blue;
			position: absolute;
			left: 30px;
			top: 15px;
			@media (max-width: @m) {
				left: 15px;
				top: 24px;
			}
		}
		&.special:before {
			.icon-store();
			font-size: 21px;
		}
	}

	.wc-package-info {
		padding: 0 30px;
		border: 1px solid @borderColor;
		border-top: none;
		font-size: 15px;
		@media (max-width: @t) {
			padding: 0 15px;
		}
	}
	.wc-package-info-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.wc-package-products-img {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		flex-grow: 1;
		padding: 10px 0 0;
	}
	.wc-package-info-more {
		padding-right: 19px;
		font-weight: 600;
		color: @blue;
		cursor: pointer;
		position: relative;
		&:before {
			.icon-arrow-down();
			font: 10px/10px @fonti;
			font-weight: 600;
			color: @blue;
			position: absolute;
			top: 7px;
			right: 0;
			.transition(transform);
		}
		&.active:before {
			.rotate(180deg);
		}

		@media (max-width: @m) {
			&:before {
				top: 8px;
			}
		}
	}

	.wc-packages-shipping-price {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		padding: 15px 0;
		border-top: 1px solid @borderColor;
	}
	.wc-package-shipping-title {
		font-size: 15px;
		font-weight: 600;
	}
	.wc-package-shipping-price {
		font-size: 15px;
		font-weight: 600;
		text-align: right;
	}

	.wc-package-items-box {
		padding: 20px 30px;
		border: 1px solid @borderColor;
		border-top: none;
		@media (max-width: @t) {
			padding: 15px;
		}
	}
	.wc-package-items-title {
		display: block;
		margin-bottom: 10px;
		font-size: 17px;
		font-weight: 600;

		@media (max-width: @m) {
			font-size: 15px;
		}
	}
	.wc-package-items {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 10px;
		position: relative;
		@media (max-width: @t) {
			grid-template-columns: 100%;
		}
	}
	.wc-package-items-loader{
		display: flex; align-items: center; justify-content: center; background: rgba(255, 255, 255, 0.3); position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 11;
		span{width: 60px; height: 60px; background: url(assets/images/loader.svg) no-repeat center; background-size: 60px; z-index: 11;}
	}
</style>
